export default {"src":"/_next/static/media/shieldIconOutline75_40.a464c5ae.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};